import { type ComponentProps, memo } from 'react';

import { ClipSource } from '@air/api/types';
import { SHARED_PANEL_ITEM_THUMBNAIL_CLASS_NAMES } from '@air/feature-file-status/constants';
import { cn } from '@air/utils-tailwind';

import {
  BrandfolderImportIcon,
  CantoImportIcon,
  DropboxImportIcon,
  FrameIoImportIcon,
  GoogleDriveImportIcon,
  HomeBoxImportIcon,
  SharePointImportIcon,
} from '~/components/Import/ui';
import { type ImporterTaskEnhanced } from '~/components/Import/utils';

export type ImportItemIconProps = Pick<ComponentProps<'div'>, 'className'> & {
  source: ImporterTaskEnhanced['args']['source'];
};

export const ImportItemIcon = memo(({ className, source }: ImportItemIconProps) => {
  const mergedClassName = cn(SHARED_PANEL_ITEM_THUMBNAIL_CLASS_NAMES, className);

  switch (source) {
    case ClipSource.dropbox:
      return <DropboxImportIcon isActive={true} className={mergedClassName} />;
    case ClipSource.googleDrive:
      return <GoogleDriveImportIcon isActive={true} className={mergedClassName} />;
    case ClipSource.box:
      return <HomeBoxImportIcon isActive={true} className={mergedClassName} />;
    case ClipSource.brandfolder:
      return <BrandfolderImportIcon isActive={true} className={mergedClassName} />;
    case ClipSource.sharePoint:
      return <SharePointImportIcon isActive={true} className={mergedClassName} />;
    case ClipSource.frameio:
      return <FrameIoImportIcon isActive={true} className={mergedClassName} />;
    case ClipSource.canto:
      return <CantoImportIcon isActive={true} className={mergedClassName} />;
    default:
      return null;
  }
});

ImportItemIcon.displayName = 'ImportItemIcon';
